// extracted by mini-css-extract-plugin
export var back = "courses-module--back--oF8oV";
export var backIcon = "courses-module--back-icon--2rnXb";
export var container = "courses-module--container--cGUYw";
export var header = "courses-module--header--bNekf";
export var list = "courses-module--list--VcMuQ";
export var loader = "courses-module--loader--aT-0M";
export var message = "courses-module--message--QEyXL";
export var switcher = "courses-module--switcher--dbBQY";
export var title = "courses-module--title--OALdS";